import React from 'react'

interface DocumentIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const SingleDocumentIcon: React.FC<DocumentIconProps> = ({
  size = 20,
  color = 'white',
  className,
  onClick,
}) => {
  return (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        className={className}
    >
        <path 
            d="M18.3337 8.33317V12.4998C18.3337 16.6665 16.667 18.3332 12.5003 18.3332H7.50033C3.33366 18.3332 1.66699 16.6665 1.66699 12.4998V7.49984C1.66699 3.33317 3.33366 1.6665 7.50033 1.6665H11.667" 
            stroke={color} 
            strokeWidth="1.3" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M18.3337 8.33317H15.0003C12.5003 8.33317 11.667 7.49984 11.667 4.99984V1.6665L18.3337 8.33317Z" 
            stroke={color} 
            strokeWidth="1.3" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
  )
}

export default SingleDocumentIcon